import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.688 42V23.892L6 6h36L29.21 23.892v11.71zM12.189 9.253l9.593 13.554v13.554l4.333-2.602V22.807l9.593-13.554z" })
});
export default SvgFilter;
